import { getErrorMsgAndCode, validateInput } from "./FrontendHelpers";
import api from "./axios";

const checkInput = (ID, Name, PriorityLevel, Permissions) => {
  return validateInput([
    {
      Name: "ID",
      Value: ID,
      Type: "roleID",
      MaxLengthType: "id",
      MinLength: 1,
    },
    {
      Name: "Name",
      Value: Name,
      Type: "string",
      MinLength: 1,
      MaxLengthType: "name",
    },
    {
      Name: "Priority level",
      Value: PriorityLevel,
      Type: "int",
      MinLength: 1,
      AllowZero: true,
      MaxLengthType: "id",
    },
    { Name: "Permission", Value: Permissions, Type: "array" },
  ]);
};

export async function GetRoles() {
  try {
    const response = await api.get("/getRoles");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetRoleMap() {
  try {
    const response = await api.get("/getRoleMap");
    const result = response.data;

    const roleMap = new Map(result);

    return [roleMap, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CreateRole(
  ID,
  Name,
  PriorityLevel,
  Color,
  Permissions,
  Warehouses
) {
  try {
    const data = { ID, Name, PriorityLevel, Color, Permissions, Warehouses };

    const inputError = checkInput(ID, Name, PriorityLevel, Permissions);
    if (inputError.errCode !== 0) return [null, inputError];

    const response = await api.post("/createRole", data);

    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function EditRole(
  CurrentID,
  ID,
  Name,
  PriorityLevel,
  Color,
  Permissions,
  Warehouses
) {
  try {
    const data = {
      CurrentID,
      ID,
      Name,
      PriorityLevel,
      Color,
      Permissions,
      Warehouses,
    };
    const inputError = checkInput(ID, Name, PriorityLevel, Permissions);
    if (inputError.errCode !== 0) return [null, inputError];
    const response = await api.post("/editRole", data);

    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetRoleData(argument, bywhat = "RoleID") {
  try {
    const data = { Argument: argument, byWhat: bywhat };
    const response = await api.post("/getRoleInfo", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNextRoleID() {
  try {
    const response = await api.get("/getNextRoleID");
    const result = response.data;
    return [result.nextID, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);

    return [null, errorObj];
  }
}

export async function DeleteRole(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/deleteRole", data);
    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForRole(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/checkForRole", data);

    const result = response.data;
    console.log("resulttt", result, result[0]);
    if (result.exists) {
      return [true, null];
    }

    return [false, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
